export default "__VITE_ASSET__Cj6EEe9j__"